import { string, table } from "@rocicorp/zero";
import { coreFields } from "./shared";

export const ticketFiles = table("ticketFiles")
	.from("ticket_files")
	.columns({
		...coreFields,
		ticketId: string().from("ticket_id"),
		fileId: string().from("file_id"),
		projectId: string().from("project_id"),
		// Optional because the column is nullable, and it is nullable because its foreign key is
		// ON DELETE SET NULL: a row whose organisation has been deleted keeps the attachment and
		// loses its tenancy. The `orgId` clause on the `_tickets.ticketFiles` hop of
		// `queries/project.queries.ts` therefore drops such a row, which is the wanted answer —
		// nobody owns it any more.
		//
		// The rows that prove the ordinary case are `apps/server/scripts/seed-storage.ts`, which
		// writes both `orgId` and `createdBy` explicitly because their defaults resolve to NULL
		// outside a request. It runs after the SQL seeds and needs `MSUITE_LOCAL_API_PORT` and
		// `MSUITE_LOCAL_SUPABASE_WORKDIR` on a shifted stack, or it refuses and this table stays
		// empty.
		orgId: string().from("org_id").optional(),
	})
	.primaryKey("id");
